module.exports = __webpack_public_path__ + "public/images/slider-arrow.34e242c8a5ad9c9b5491b7153f41f8db.svg";